// extracted by mini-css-extract-plugin
export default {"tags":"tags-bbcad406","tag":"tag-c407a836","checked":"checked-a6711abc"};